jQuery($ => {
    class Meganav {
      constructor(element) {
        this._           = element;
        this._element    = $(element);
        this._focusables = this._element.find('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');
        this._submenuToggles = this._element.find('.m-menu-option[aria-controls]');
        this._columns    = this._element.children('.m-meganav__column');
        this._toggle     = this._element.closest('.u-toggle');

        this.init();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      init() {
        this.setupHandlers();
        this.positionPanel();
        this._columns.each((_, column) => this.updateColumnState($(column)));
        this._element.trigger( 'init', this );
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      setupHandlers() {
        this._focusables.on('keydown', this.handleKeydown);
        this._submenuToggles.on('click', this.handleSubmenuToggleClick);
        this._toggle.on('toggle:on', this.positionPanel);
        $(window).on('resize', this.positionPanel);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Visible Focusables
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      getVisibleFocusables = ($context) => {
        const $scope = $context || this._element;
        return $scope.find('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')
          .filter((_, el) => !$(el).closest('[aria-hidden="true"]').length);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Submenu For Toggle
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      getSubmenu = ($toggle) => {
        return this._element.find(`#${$toggle.attr('aria-controls')}`);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Position Panel
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      // Center the panel under its control, clamped inside the viewport
      // gutters. Drives the panel's `left` via --toggle-target-x-position
      // on the panel element (the toggle-level var also positions the caret,
      // which must stay under the control).
      positionPanel = () => {
        const control = document.getElementById(this._element.data('controlledby'));

        if (!control) return;

        const $offsetParent = this._element.offsetParent();
        const parentRect    = $offsetParent.length ? $offsetParent[0].getBoundingClientRect() : { left: 0 };
        const controlRect   = control.getBoundingClientRect();
        const half          = this._element.outerWidth() / 2;
        const gutter        = 30;
        const center        = controlRect.left + controlRect.width / 2;
        const clamped       = Math.min(Math.max(center, half + gutter), window.innerWidth - half - gutter);

        this._element.css('--toggle-target-x-position', `${clamped - parentRect.left}px`);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Update Column State
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      updateColumnState = ($column) => {
        const $swappable = $column.children('.m-meganav__feature, .m-meganav__submenu');
        const isEmpty    = $swappable.length > 0 &&
          !$swappable.filter((_, el) => $(el).attr('aria-hidden') !== 'true').length;

        $column.toggleClass('m-meganav__column--empty', Boolean(isEmpty));
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Open Submenu
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      openSubmenu = ($toggle) => {
        const $panel = this.getSubmenu($toggle);
        const level  = parseInt($panel.data('level'), 10);

        this._submenuToggles.each((_, toggle) => {
          const $other = $(toggle);

          if ($other.attr('aria-expanded') === 'true' &&
              parseInt(this.getSubmenu($other).data('level'), 10) >= level) {
            this.closeSubmenu($other);
          }
        });

        $panel.siblings('.m-meganav__feature, .m-meganav__submenu').attr('aria-hidden', 'true');
        $panel.attr('aria-hidden', 'false');
        $toggle.attr('aria-expanded', 'true');
        this.updateColumnState($panel.parent());
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Close Submenu
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      closeSubmenu = ($toggle) => {
        const $panel = this.getSubmenu($toggle);

        $panel.attr('aria-hidden', 'true');
        $toggle.attr('aria-expanded', 'false');

        const $column = $panel.parent();

        if (!$column.find('.m-meganav__submenu[aria-hidden="false"]').length) {
          $column.children('.m-meganav__feature').attr('aria-hidden', 'false');
        }

        this.updateColumnState($column);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Close Submenu And Deeper Levels
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      closeSubmenuTree = ($toggle) => {
        const level = parseInt(this.getSubmenu($toggle).data('level'), 10);

        this._submenuToggles.each((_, toggle) => {
          const $other = $(toggle);

          if ($other.attr('aria-expanded') === 'true' &&
              parseInt(this.getSubmenu($other).data('level'), 10) >= level) {
            this.closeSubmenu($other);
          }
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Move Focus To Adjacent Column
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      focusAdjacentColumn = ($current, direction) => {
        const $column = $current.closest('.m-meganav__column');
        let index     = this._columns.index($column) + direction;
        let $target   = this._columns.eq(index);

        while ($target.length) {
          const $focusables = this.getVisibleFocusables($target);

          if ($focusables.length) {
            $focusables.first().focus();
            return;
          }

          index   += direction;
          $target  = this._columns.eq(index);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Submenu Toggle Click
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleSubmenuToggleClick = (event) => {
        event.preventDefault();

        const $toggle = $(event.currentTarget);

        if ($toggle.attr('aria-expanded') === 'true') {
          this.closeSubmenuTree($toggle);
        } else {
          this.openSubmenu($toggle);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleKeydown = (event) => {
        const $current  = $(event.currentTarget);
        const $submenu  = $current.closest('.m-meganav__submenu');
        const $column   = $current.closest('.m-meganav__column');
        const $items    = this.getVisibleFocusables($column);
        const index     = $items.index($current);

        switch (event.key) {
          case 'ArrowUp':
            event.preventDefault();

            if (index > 0) {
              $items.eq(index - 1).focus();
            } else {
              $items.last().focus();
            }

            break;

          case 'ArrowDown':
            event.preventDefault();

            if (index >= 0 && index < $items.length - 1) {
              $items.eq(index + 1).focus();
            } else {
              $items.first().focus();
            }

            break;

          case 'ArrowRight':
            event.preventDefault();

            if ($current.is('[aria-controls]')) {
              this.openSubmenu($current);
              this.getVisibleFocusables(this.getSubmenu($current)).first().focus();
            } else {
              this.focusAdjacentColumn($current, 1);
            }

            break;

          case 'ArrowLeft':
            event.preventDefault();

            if ($submenu.length) {
              const $parent = this._element.find(`#${$submenu.attr('aria-labelledby')}`);

              this.closeSubmenuTree($parent);
              $parent.focus();
            } else {
              this.focusAdjacentColumn($current, -1);
            }

            break;

          case 'Esc':
          case 'Escape':
            if ($submenu.length) {
              event.preventDefault();
              event.stopImmediatePropagation();

              const $parent = this._element.find(`#${$submenu.attr('aria-labelledby')}`);

              this.closeSubmenuTree($parent);
              $parent.focus();
            } else if ($current.is('[aria-expanded="true"]')) {
              event.preventDefault();
              event.stopImmediatePropagation();

              this.closeSubmenuTree($current);
            }

            break;
        }
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.meganav = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].meganav = new Meganav(_[i], opt);
        else
          ret = _[i].meganav[opt].apply(_[i].meganav, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.m-meganav').meganav();
});
